import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const NewSettingsDomainLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLight" */ './NewSettingsDomainSuspense')
);

export const SettingsDomainAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <NewSettingsDomainLazy />
    </DelayedSuspense>
);
